/**
 * Hook to access read-only mode state
 */
import { useReadOnlyContext } from '../context/ReadOnlyContext';

export const useReadOnlyMode = () => {
  const { isReadOnly, setReadOnlyMode, hasAccessToReadOnlyMode } = useReadOnlyContext();

  return {
    isReadOnly,
    setReadOnlyMode,
    hasAccessToReadOnlyMode,
  };
};
